import React from 'react'
import {useSuspense} from '@data-client/react'
import {ActionHeader, UserNoCanDo} from '../components'
import {MembersTable} from '../components/Team'
import {MemberResource} from '../lib/model'
import {IconAdd} from '../Icons'
import {PageProps} from '../components/PageRouter'
import {Button, Container} from '@mui/material'

export default function TeamPage({settings, session}: PageProps) {
  const members = useSuspense(MemberResource.getList, {teamId: settings.id})
  if (!session.scope.isTeamLead) {
    return <UserNoCanDo />
  }
  return (
    <Container maxWidth="md">
      <ActionHeader title="Team Members">
        <Button href="./member/add" color="primary">
          <IconAdd /> &nbsp; Add
        </Button>
      </ActionHeader>
      <MembersTable users={members} />
    </Container>
  )
}
